import { render, staticRenderFns } from "./HighlightsCommentTriggerParts.vue?vue&type=template&id=fba92c66&scoped=true"
import script from "./HighlightsCommentTriggerParts.vue?vue&type=script&lang=ts"
export * from "./HighlightsCommentTriggerParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsCommentTriggerParts.vue?vue&type=style&index=0&id=fba92c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba92c66",
  null
  
)

export default component.exports